// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Y8ngK","avatarContainer":"styles_avatarContainer__r3MOz","addressContainer":"styles_addressContainer__RU_yK"};